import React from "react";

export const DashboardContext = React.createContext();
export const JobContext = React.createContext();
export const ChatContext = React.createContext();
export const ToastContext = React.createContext(null);
export const CategoryFormContext = React.createContext(null);
export const ExperimentContext = React.createContext(null);
